import moment from 'moment';
import { DEFAULT_DATE_TYPES } from '../constants';

import type { IDateType, IDateValue, IMomentDateValue } from '@/pages/intelligence/types/common';

export function getValidDateType(dateType: IDateType, defaultDateType?: IDateType): IDateType {
  if (DEFAULT_DATE_TYPES?.includes(dateType)) return dateType;
  return DEFAULT_DATE_TYPES?.[0] || defaultDateType || 'date';
}

export function getValidDateValue(dateValue: IDateValue, defaultDateValue: IDateValue = []): IDateValue {
  if (!Array.isArray(dateValue)) return [];
  const dateValueTemp = dateValue.filter((item) => typeof item === 'string' && !!item?.trim());
  return dateValueTemp.length === 2 ? dateValueTemp : defaultDateValue;
}

export function getMomentDateValue(dateValue: IDateValue): IMomentDateValue {
  if (!Array.isArray(dateValue)) return [];
  const result: IMomentDateValue = [];
  for (const item of dateValue) {
    const mItem = moment(item);
    if (mItem.isValid()) {
      result.push(mItem);
    }
  }
  return result.length === 2 ? result : [];
}
